var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconSignalYellow = function SvgIconSignalYellow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-500.000000, -638.000000) translate(500.000000, 638.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.5,
    height: 26.5,
    x: 0.75,
    y: 0.75,
    fill: "#FFF",
    rx: 13.25
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FA6400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.118,
    d: "M13.5 18.5L13.5 12.25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DDE3E3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.118,
    d: "M17.25 18.5L17.25 8.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FA6400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.118,
    d: "M9.75 18.5L9.75 16"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconSignalYellow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-signal-yellow.6bf164b64a34c40ed4da1479191ce572.svg";